import StripeChargeListStore from '@modules/stripe/stripe-charge/stripe-charge-list-store';

export default {
        namespaced: true,

        modules: {
                list: StripeChargeListStore,
        },
};